import { VideoGreetingsCardBlock } from "../../blocks";
import CategoriesBlock from "../../blocks/categories";
import { EditableTextBlock } from "../../utils";

export const AboutUsPage = () => {
    return <>
        <section className="section s-about">
            <div className="s-about__inner inside-wrapper">

                <div className="s-about__box">


                    <div className="s-about__text">
                        <h2 className="s-about__title">
                            Welcome to Slidy!
                        </h2>
                        <p>
							<EditableTextBlock definedName="about-us-block-welcome" title="About us - welcome to Slidy">
                            {`At&nbsp;Slidy, we&nbsp;transform your cherished photos into stunning video clip. Whether it&rsquo;s a&nbsp;birthday, a&nbsp;family
                            holiday, or&nbsp;a&nbsp;romantic moment, we&nbsp;provide a&nbsp;seamless way to&nbsp;create beautiful video stories that capture
                            your memories perfectly.`}
							</EditableTextBlock>
                        </p>
                    </div>

                    <img className="s-about__img" src="./img/about01.svg" alt="" width="487" height="317"/>

                </div>
                <div className="s-about__box">


                    <img className="s-about__img" src="./img/about02.svg" alt="" width="491" height="531"/>

                    <div className="s-about__text">
                        <h2 className="s-about__title">
                            Our Story
                        </h2>
						<EditableTextBlock definedName="about-us-block-our-story" title="About us - our story">
                        {`Having worked as&nbsp;professional photographers for many years, we&rsquo;ve observed that clients often desire a&nbsp;service that allows them to&nbsp;see their photos in&nbsp;a&nbsp;fresh, dynamic way. Traditional photos no&nbsp;longer have the same impact; people now crave captivating visual experiences. There wasn&rsquo;t a&nbsp;service where individuals could easily upload their photos and receive a&nbsp;stunning video story.`}

                        {`The available services offer overly simplistic solutions that no&nbsp;longer impress. Hiring a&nbsp;designer to&nbsp;create a&nbsp;video from photos can be&nbsp;prohibitively expensive, and purchasing a&nbsp;template from stock services often requires basic animation skills, additional editing software, plugins, and a&nbsp;powerful computer to&nbsp;handle lengthy rendering times.`}


                        {`We&nbsp;created a&nbsp;service that effortlessly transforms your photos into amazing stories with beautiful animations. Share them with friends on&nbsp;social media, gift them to&nbsp;loved ones as&nbsp;video greeting cards, or&nbsp;watch them on&nbsp;your TV&rsquo;s big screen. Our video stories allow you to&nbsp;rediscover your photos in&nbsp;an&nbsp;engaging and exciting format, providing endless enjoyment each time you view them.`}
							</EditableTextBlock>
                    </div>


                </div>


            </div>
        </section>
        <CategoriesBlock
         showDescriptions={true}
         title={`What We Offer`} 
         text={`Upload your photos and choose from our extensive library of&nbsp;video stories.\nEach story is&nbsp;designed to&nbsp;fit specific occasions and themes, ensuring your video is&nbsp;tailored to&nbsp;your needs.`} />
         <VideoGreetingsCardBlock />
         <section className="section section_gray s-hiw">
			<div className="inside-wrapper">

				<h2 className="section__title">
					Our Process
				</h2>
				<div className="section__subtitle">
					Creating your perfect video is&nbsp;simple:
				</div>

				<ul className="s-hiw__list s-hiw__list_alt">

					<li className="s-hiw__item s-hiw__item_alt">
						<figure className="s-hiw__fig">
							<picture className="s-hiw__pic">
								<img className="s-hiw__img" src="./img/hiw2_01.svg" alt="" width="300" />
							</picture>
							<figcaption className="s-hiw__caption s-hiw__caption_small">
								Choose video templates
							</figcaption>
						</figure>
						<div className="s-hiw__descr">
							Browse through our categoriesand select a&nbsp;video storythat fits your occasion
						</div>
					</li>
					<li className="s-hiw__item s-hiw__item_alt">
						<figure className="s-hiw__fig">
							<picture className="s-hiw__pic">
								<img className="s-hiw__img" src="./img/hiw2_02.svg" alt="" width="300" />
							</picture>
							<figcaption className="s-hiw__caption s-hiw__caption_small">
								Upload your photos
							</figcaption>
						</figure>
						<div className="s-hiw__descr">
							Easily select and upload your photos from your phone, tablet, computer, Instagram, Google Photos, and Dropbox accounts
						</div>
					</li>
					<li className="s-hiw__item s-hiw__item_alt">
						<figure className="s-hiw__fig">
							<picture className="s-hiw__pic">
								<img className="s-hiw__img" src="./img/hiw2_03.svg" alt="" width="300" />
							</picture>
							<figcaption className="s-hiw__caption s-hiw__caption_small">
								Download your video
							</figcaption>
						</figure>
						<div className="s-hiw__descr">
							Download the finished video to&nbsp;your phone, tablet, or&nbsp;computer, order it&nbsp;as&nbsp;a&nbsp;gift on&nbsp;a&nbsp;video greeting card, or&nbsp;watch it&nbsp;online on&nbsp;our platform.
						</div>
					</li>


				</ul>




			</div>
		</section>

		<section className="section section_gray s-hiw">
			<div className="inside-wrapper">

				<h2 className="section__title">
					Our Process
				</h2>
				<div className="section__subtitle">
					Creating your perfect video is&nbsp;simple:
				</div>

				<ul className="s-hiw__list s-hiw__list_alt">

					<li className="s-hiw__item s-hiw__item_alt">
						<figure className="s-hiw__fig">
							<picture className="s-hiw__pic">
								<img className="s-hiw__img" src="./img/hiw2_04.svg" alt="" width="300" />
							</picture>
							<figcaption className="s-hiw__caption s-hiw__caption_big">
								Unique Service
							</figcaption>
						</figure>
						<div className="s-hiw__descr">
							This is&nbsp;a&nbsp;unique service with no&nbsp;existing equivalent in&nbsp;the world
						</div>
					</li>
					<li className="s-hiw__item s-hiw__item_alt">
						<figure className="s-hiw__fig">
							<picture className="s-hiw__pic">
								<img className="s-hiw__img" src="./img/hiw2_05.svg" alt="" width="300" />
							</picture>
							<figcaption className="s-hiw__caption s-hiw__caption_big">
								Quality
							</figcaption>
						</figure>
						<div className="s-hiw__descr">
							We&nbsp;pride ourselves on&nbsp;delivering high-quality, visually stunning video stories
						</div>
					</li>
					<li className="s-hiw__item s-hiw__item_alt">
						<figure className="s-hiw__fig">
							<picture className="s-hiw__pic">
								<img className="s-hiw__img" src="./img/hiw2_06.svg" alt="" width="300" />
							</picture>
							<figcaption className="s-hiw__caption s-hiw__caption_big">
								Easy to Use
							</figcaption>
						</figure>
						<div className="s-hiw__descr">
							Our platform is&nbsp;designed for ease of&nbsp;use, ensuring a&nbsp;smooth and enjoyable experience
						</div>
					</li>


				</ul>


				<div className="s-hiw__btns">

					<a href="#" className="btn btn_cta btn_lg btn_extrapad">Get Started Today</a>

				</div>

				<div className="s-hiw__note">
					Ready to&nbsp;turn your photos into a&nbsp;beautiful video story? Explore our categories and start creating today. <br /> Whether it&rsquo;s a&nbsp;memorable gift or&nbsp;a&nbsp;professional business video, Slidy is&nbsp;here to&nbsp;help you bring your memories to&nbsp;life.
				</div>




			</div>
		</section>
    </>
}

export default AboutUsPage;